import { useEffect, useState } from "react";

import { safeAPI, logError } from "../../../../utils/appUtils";

/**
 * Safe identity subset for a gate-enrolled driver. The fields live on the
 * admin-locked CarrierUserIdentity table, so they arrive through the
 * manager-gated driverAdmin endpoint rather than the record. Returns null
 * until the lookup answers; a non-driver, a driver with no identity row
 * (404), or a transient failure just stays null.
 */
export const useDriverIdentity = (record) => {
  const [identity, setIdentity] = useState(null);
  const carrierUserId = record?.userType === "driver" ? record.id : null;

  useEffect(() => {
    if (!carrierUserId) return undefined;
    let cancelled = false;
    safeAPI
      .post("transREST", "/driverAdmin/identity", {
        body: { carrierUserId },
      })
      .then((data) => {
        if (!cancelled) setIdentity(data);
      })
      .catch((error) => {
        logError("managerApp:carrierUsers:useDriverIdentity", error, false);
      });
    return () => {
      cancelled = true;
    };
  }, [carrierUserId]);

  return identity;
};
